import React from "react";

// My Imports
import ActivationHistory from "views/my/activation-history";
import PendingActivations from "views/my/pending-activations";
import NewActivation from "views/my/new-activation";
import ResellerOrderDetail from "views/my/reseller-order-detail";
import ConfirmActivation from "views/my/confirm-activation";
import ActivationDetails from "views/my/activation-details";
import ChangePassword from "views/my/change-password";
import Onsite from "views/my/onsite";
import Cloud from "views/my/cloud";
import ActivationSummary from "views/my/activation-summary";
import Servers from "views/my/servers";

// Auth Imports
import SignIn from "views/auth/SignIn";
import ResetPassword from "views/auth/ResetPassword";
import ForgotPassword from "views/auth/ForgotPassword";

import NotFound from "views/NotFound";

// Icon
import PauseIcon from "components/icons/PauseIcon";
import AddIcon from "components/icons/AddIcon";
import CheckIcon from "components/icons/CheckIcon";
import ServerIcon from "components/icons/ServerIcon";
import GlobeIcon from "components/icons/GlobeIcon";
import ServerDetails from "views/my/server-details";
import Domains from "views/my/domains";
import DomainDetails from "views/my/domain-details";
import RequestNewAccount from "./views/auth/RequestNewAccount";
import Homepage from "./views/my/homepage";

const routes = [
    {
        name: "Cruscotto",
        layout: "/my",
        path: "homepage",
        component: <Homepage />,
        sidebar: true,
    },
    {
        name: "Nuova attivazione",
        layout: "/my",
        path: "new-activation",
        icon: <AddIcon />,
        component: <NewActivation />,
        sidebar: true,
        group: 1,
    },
    {
        name: "Dettaglio ordine",
        layout: "/my",
        path: "reseller-order-detail/:code",
        component: <ResellerOrderDetail />,
        sidebar: false,
    },
    {
        name: "Attivazione Proxima Onsite",
        layout: "/my",
        path: "activation-onsite",
        icon: <AddIcon />,
        component: <Onsite />,
        sidebar: false,
    },
    {
        name: "Attivazione Proxima Cloud",
        layout: "/my",
        path: "activation-cloud",
        icon: <AddIcon />,
        component: <Cloud />,
        sidebar: false,
    },
    {
        name: "Attivazione Proxima Onsite",
        layout: "/my",
        path: "activation-onsite/:code",
        icon: <AddIcon />,
        component: <Onsite />,
        sidebar: false,
    },
    {
        name: "Attivazione Proxima Cloud",
        layout: "/my",
        path: "activation-cloud/:code",
        icon: <AddIcon />,
        component: <Cloud />,
        sidebar: false,
    },
    {
        name: "Storico attivazioni",
        layout: "/my",
        path: "activation-history",
        icon: <CheckIcon />,
        component: <ActivationHistory />,
        sidebar: true,
        group: 1,
    },
    {
        name: "Attivazioni in sospeso",
        layout: "/my",
        path: "pending-activations",
        icon: <PauseIcon />,
        component: <PendingActivations />,
        sidebar: true,
        group: 1,
    },
    {
        name: "Login",
        layout: "/auth",
        path: "sign-in",
        component: <SignIn />,
        sidebar: false,
    },
    {
        name: "Reset Password",
        layout: "/auth",
        path: "reset-password/:token",
        component: <ResetPassword />,
        sidebar: false,
    },
    {
        name: "Forgot Password",
        layout: "/auth",
        path: "forgot-password",
        component: <ForgotPassword />,
        sidebar: false,
    },
    {
        name: "Request new account",
        layout: "/auth",
        path: "request-new-account",
        component: <RequestNewAccount />,
        sidebar: false,
    },
    {
        name: "Conferma attivazione",
        layout: "/my",
        path: "confirm-activation/:code",
        component: <ConfirmActivation />,
        sidebar: false,
    },
    {
        name: "Dettaglio attivazione",
        layout: "/my",
        path: "activation-details/:code",
        component: <ActivationDetails />,
        sidebar: false,
    },
    {
        name: "Riepilogo attivazione",
        layout: "/my",
        path: "activation-summary/:code",
        component: <ActivationSummary />,
        sidebar: false,
    },
    {
        name: "Profilo",
        layout: "/my",
        path: "change-password",
        component: <ChangePassword />,
        sidebar: false,
    },
    {
        name: "Server",
        layout: "/my",
        path: "servers",
        icon: <ServerIcon />,
        component: <Servers />,
        sidebar: true,
        group: 2,
    },
    {
        name: "Dettaglio Server",
        layout: "/my",
        path: "server/:code",
        component: <ServerDetails />,
        sidebar: true,
    },
    {
        name: "Tenant",
        layout: "/my",
        path: "domains",
        icon: <GlobeIcon />,
        component: <Domains />,
        sidebar: true,
        group: 3,
    },
    {
        name: "Dettaglio Tenant",
        layout: "/my",
        path: "domain/:code",
        component: <DomainDetails />,
        sidebar: true,
    },
    {
        path: "*",
        component: <NotFound />,
        sidebar: false,
    },
];
export default routes;
